(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-coupon/assets/javascripts/use-countdown.js') >= 0) return;  svs.modules.push('/components/tipsen/route-coupon/assets/javascripts/use-countdown.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _dateFns = dateFns,
  differenceInSeconds = _dateFns.differenceInSeconds,
  parseISO = _dateFns.parseISO,
  differenceInMonths = _dateFns.differenceInMonths,
  differenceInWeeks = _dateFns.differenceInWeeks,
  differenceInDays = _dateFns.differenceInDays,
  differenceInHours = _dateFns.differenceInHours,
  differenceInMinutes = _dateFns.differenceInMinutes,
  isDate = _dateFns.isDate;
const defaultTimeLeft = {
  totalSecondsLeft: 0,
  months: 0,
  weeks: 0,
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
};
const useCountdown = function (dateInput) {
  let intervalInSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const prevDateInput = useRef(dateInput);
  const targetDate = dateInput && (isDate(dateInput) ? dateInput : parseISO(dateInput));
  const calculateTimeLeft = useCallback(() => {
    if (!targetDate) {
      return defaultTimeLeft;
    }
    const totalSecondsLeft = Math.max(differenceInSeconds(targetDate, new Date()), 0);
    const months = differenceInMonths(targetDate, new Date());
    const weeks = differenceInWeeks(targetDate, new Date()) % 4;
    const days = differenceInDays(targetDate, new Date()) % 7;
    const hours = differenceInHours(targetDate, new Date()) % 24;
    const minutes = differenceInMinutes(targetDate, new Date()) % 60;
    const seconds = totalSecondsLeft % 60;
    return {
      totalSecondsLeft,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds
    };
  }, [targetDate]);
  const _useState = useState(calculateTimeLeft),
    _useState2 = _slicedToArray(_useState, 2),
    timeLeft = _useState2[0],
    setTimeLeft = _useState2[1];
  useEffect(() => {
    if (!targetDate) {
      setTimeLeft({
        totalSecondsLeft: 0,
        months: 0,
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      });
      return;
    }

    if (dateInput !== prevDateInput.current) {
      setTimeLeft(calculateTimeLeft());
      prevDateInput.current = dateInput;
    }
    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();

      setTimeLeft(prevTimeLeft => {
        if (newTimeLeft.totalSecondsLeft !== prevTimeLeft.totalSecondsLeft) {
          return newTimeLeft;
        }
        return prevTimeLeft;
      });
      if (newTimeLeft.totalSecondsLeft <= 0) {
        clearInterval(interval);
      }
    }, intervalInSeconds * 1000);
    return () => clearInterval(interval);
  }, [dateInput, intervalInSeconds, calculateTimeLeft, targetDate]);
  return {
    hasPassed: timeLeft.totalSecondsLeft === 0,
    timeLeft: {
      months: timeLeft.months,
      weeks: timeLeft.weeks,
      days: timeLeft.days,
      hours: timeLeft.hours,
      minutes: timeLeft.minutes,
      seconds: timeLeft.seconds
    },
    timeLeftInSeconds: timeLeft.totalSecondsLeft
  };
};
setGlobal('svs.components.tipsen.routeCoupon.useCountdown', useCountdown);

 })(window);